/* Elegance Coque — cartes produits : badge adapté au produit, lignes discrètes sous le prix (icônes en contour) :
   « Livraison gratuite » (ou « Livraison : 35 DH » pour les accessoires seuls) et « Photos 100 % réelles », notes réelles uniquement.
   Réutilise la ligne existante (.lcard__ship) : elle est remplacée, jamais doublée.
   31-10 : pastilles de couleur masquées (sans espace) quand le produit n'a qu'une seule couleur.
   Données : templates/collection.ec-meta.liquid (gardées 10 min). */
(function () {
  if (window.__ecplus) { return; }
  window.__ecplus = true;
  var d = document, W = window, META = null, KEY = 'ec-meta-v1', TTL = 600000, t = 0;
  var PRICE = '.lcard__price,.ec-p__price,.ecx-card__price,.lcg-card__price,.lmk-p__price,.lau__price,.ecb-card__price,.lac-card__price,.lwl-card__price,product-price,.price';
  var MEDIA = '.lcard__media,.ec-p__media,.ecx-card__media,.lcg-card__media,.lmk-p__media,.lau__media,.ecb-card__media,.lac-card__media,.lwl-card__media,.card-gallery';
  var TRUCK = '<svg class="ecx-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2.5 6.5h11v9.5h-11z"/><path d="M13.5 9.5h4.2l3 3.3V16h-7.2"/><circle cx="6.5" cy="17.2" r="1.7"/><circle cx="17" cy="17.2" r="1.7"/></svg>';
  var CAM = '<svg class="ecx-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.5 8.5h3.2l1.6-2.5h7.4l1.6 2.5h3.2v10h-17z"/><circle cx="12" cy="13.2" r="3.4"/></svg>';
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4-4.7-4.4 6.4-.8z"/></svg>';

  function load(cb) {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && c.p && c.t > Date.now() - TTL) { cb(c.p); return; }
    } catch (e) {}
    var root = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
    fetch(root + 'collections/all?view=ec-meta', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (txt) {
        var j = null;
        try { j = JSON.parse(txt); } catch (e) {}
        if (!j || !j.p) { return; }
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), p: j.p })); } catch (e) {}
        cb(j.p);
      })
      .catch(function () {});
  }

  function handleOf(c) {
    var b = c.querySelector('[data-ecca][data-handle]');
    if (b) { return b.getAttribute('data-handle'); }
    var a = c.querySelector('a[href*="/products/"]');
    var u = a ? a.getAttribute('href') : (c.getAttribute('data-url') || '');
    var m = /\/products\/([^\/?#]+)/.exec(u);
    if (!m) { return ''; }
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function cardList() {
    var s = [];
    [].forEach.call(d.querySelectorAll('.ecca'), function (a) { var c = a.parentElement; if (c && s.indexOf(c) < 0) { s.push(c); } });
    [].forEach.call(d.querySelectorAll('.ecx-card,.lcg-card'), function (c) { if (s.indexOf(c) < 0) { s.push(c); } });
    return s;
  }

  /* pastilles : affichées seulement s'il existe au moins deux couleurs */
  function swatches() {
    [].forEach.call(d.querySelectorAll('.lsw,.ecx-sw'), function (el) {
      var n = el.querySelectorAll('button,.lsw__more').length;
      var one = n <= 1;
      if (el.classList.contains('ecx-sw-one') !== one) { el.classList.toggle('ecx-sw-one', one); }
    });
  }

  function rate(m) {
    var r = Math.round((+m.r || 0) * 10) / 10;
    return '<span class="ecx-rate" aria-label="Note ' + String(r).replace('.', ',') + ' sur 5, ' + m.n + ' avis">' + STAR + '<span><b>' + String(r).replace('.', ',') + '</b> (' + m.n + ' avis)</span></span>';
  }
  function line(icon, txt) { return '<span class="ecx-ship">' + icon + '<span>' + txt + '</span></span>'; }

  function badge(c, m) {
    if (!m.b || c.querySelector('.ecx-bdg')) { return; }
    var other = [].some.call(c.querySelectorAll('[class*="badge"]'), function (e) { return e.offsetParent !== null && e.textContent.trim() !== ''; });
    if (other) { return; }
    var media = c.querySelector(MEDIA);
    if (!media) { var im = c.querySelector('img'); media = im && im.parentElement; }
    if (!media) { return; }
    media.classList.add('ecx-host');
    var s = d.createElement('span');
    s.className = 'ecx-bdg ecx-bdg--' + (m.k || 'cat');
    s.textContent = m.b;
    media.appendChild(s);
    if (m.k === 'off') { c.classList.add('ecx-is-off'); }
  }

  function info(c, m) {
    if (c.querySelector('.ecx-info')) { return; }
    var price = c.querySelector(PRICE);
    if (!price) { return; }
    var old = null;
    [].some.call(c.children, function (e) { if (e.classList.contains('lcard__ship')) { old = e; return true; } return false; });
    var fee = !!(old && old.classList.contains('lcard__ship--fee'));
    var ship = fee ? line(TRUCK, 'Livraison : 35 DH') : (m && m.f ? line(TRUCK, 'Livraison gratuite') : '');
    var hasRate = m && (+m.n > 0) && (+m.r > 0);
    var html = ship + line(CAM, 'Photos 100&nbsp;% réelles') + (hasRate ? rate(m) : '');
    if (price.parentElement === c) {
      var el = d.createElement('div');
      el.className = 'lcard__ship ecx-info';
      el.innerHTML = html;
      if (old) { old.classList.add('ecx-old'); c.insertBefore(el, old); } else { price.insertAdjacentElement('afterend', el); }
    } else {
      var sp = d.createElement('span');
      sp.className = 'ecx-info ecx-info--in';
      sp.innerHTML = html;
      price.classList.add('ecx-p');
      price.appendChild(sp);
    }
  }

  function run() {
    swatches();
    if (!META) { return; }
    cardList().forEach(function (c) {
      if (!c.querySelector('a[href*="/products/"]') && !c.querySelector('[data-ecca][data-handle]')) { return; }
      var m = META[handleOf(c)];
      if (!m) { return; }
      badge(c, m);
      info(c, m);
    });
  }
  function later() { W.clearTimeout(t); t = W.setTimeout(run, 120); }
  function boot() {
    swatches();
    if (W.MutationObserver) { new MutationObserver(later).observe(d.body, { childList: true, subtree: true }); }
    W.addEventListener('load', run);
    load(function (p) { META = p; run(); });
  }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  W.addEventListener('pageshow', function (e) { if (e.persisted) { run(); } });
})();
